import React from 'react';
import { Box, Typography } from '@mui/material';
import { ECardTypes } from 'shared/types/card.interface';
import { PAGE_PLACEHOLDERS_DATA } from 'shared/constants/no-content-constants';
import { IChallangeData } from 'shared/types/challenges.interface';
import Card from 'components/Card/Card';
import SkeletonCardList from 'components/Skeletons/CardSkeleton/SkeletonCardList/SkeletonCardList';
import { useGetMyChallengesQuery } from 'redux/api/challenge.api';
import { CardsContainer } from 'components/Card/CardsContainer/CardsContainer';

const MyChallenges: React.FunctionComponent<any> = () => {
  const { data: myChallenges = [], isLoading } = useGetMyChallengesQuery(undefined, {
    skip: window.location.pathname !== '/my-challenges',
    pollingInterval: 1000,
    refetchOnMountOrArgChange: true,
  });

  return (
    <CardsContainer>
      {isLoading ? (
        <SkeletonCardList />
      ) : myChallenges.length ? (
        myChallenges.map((challenge: IChallangeData) => (
          <Card cardInfo={challenge} type={ECardTypes.Challenge} key={challenge.id} />
        ))
      ) : (
        <Box sx={{ width: '100%', textAlign: 'center' }}>
          <Typography variant="body1" color="primary.main">
            {PAGE_PLACEHOLDERS_DATA.myChallenges}
          </Typography>
        </Box>
      )}
    </CardsContainer>
  );
};

export default MyChallenges;
